/**
 * theme-picker.js
 */


import React from 'react';
import { Tooltip } from '@mui/material';
import { Types } from 'utils/constants';
import { UserDataContext } from 'contexts/user-data/user-data-context';
import { ThemeContext } from 'contexts/theme/theme-context';
import Icon from 'components/icon/icon';
import BarButton from 'components/layout/app-bar/bar-button';


const ThemePicker = (props) => {
  const { themeId } = React.useContext(ThemeContext);
  const { setUserTheme } = React.useContext(UserDataContext);


  const toggleCurrentTheme = React.useCallback(() => {
    setUserTheme(themeId === Types.Theme.LIGHT ? Types.Theme.DARK : Types.Theme.LIGHT);
  }, [themeId, setUserTheme]); 
  

  React.useEffect(() => {
    const keydownHandler = e => {
      if (e.ctrlKey && e.altKey && e.shiftKey && e.key === 'D') {
        toggleCurrentTheme();
      }
    };

    window.addEventListener("keydown", keydownHandler);
    return () => window.removeEventListener("keydown", keydownHandler);
  }, [toggleCurrentTheme]);


  return (
    <Tooltip
      arrow
      placement='bottom'
      title='Toggle dark/light mode'
    >
      <span style={{ display: 'inline-block' }}>
        <BarButton onClick={() => toggleCurrentTheme()}>
          <Icon 
            type='dark-mode-toggle' 
            sx={{
              transformOrigin: 'center',
              transition: 'transform .5s cubic-bezier(0.33, 1, 0.68, 1)',
              transform: theme => `scaleX(${theme.palette.isDarkMode ? 1 : -1})`,
            }}
          />
        </BarButton>
      </span>
    </Tooltip>
  );
};


export default ThemePicker;